import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { WarmingUpCollections } from '@wg/wows-entities/const';
import { ManagerData } from '~/core/ManagerData';
import { logInfo } from '~/utils/logging';

export interface IShipFeatures {
    shipFeatureMap: ShipFeatureMap;
}

const initialState: Partial<IShipFeatures> = {
    shipFeatureMap: {},
};

export const fetchFeatures = createAsyncThunk('ship_features/load', async () => {
    try {
        const response = ManagerData.getDataBySection(WarmingUpCollections.features);
        return response;
    } catch (e) {
        logInfo('response not successful for item');
    }
});

export const shipFeaturesSlice = createSlice({
    name: 'ship_features',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchFeatures.fulfilled, (state, action) => {
            state.shipFeatureMap = action.payload;
        });
    },
});

export const shipFeatures = shipFeaturesSlice.actions;

export default shipFeaturesSlice.reducer;
